import { logout } from '@libs/api-proxy-client';
import { logoutUser as logoutUserCore } from '@libs/core';

type LogoutUserParams = Omit<Parameters<typeof logoutUserCore>[0], 'performApiLogout'>;

/**
 * Performs API logout calls using apiProxyClient v2
 * This is frontend-specific and should not be used in backend code
 */
export async function performApiLogout(accessToken: string): Promise<boolean> {
    const isValidResponse = (res: unknown): res is Exclude<typeof res, null | Error> => {
        return res !== null && !(res instanceof Error);
    };

    if (!accessToken) {
        return false;
    }

    // removeAuthTokens() was already called, so getAccessToken() will return null
    const resLogout = await logout(accessToken);
    return isValidResponse(resLogout) && (resLogout as { status?: string })?.status === 'ok';
}

/**
 * Frontend-specific logout function that uses apiProxyClient v2
 * This wraps the core logoutUser function with frontend-specific API logout logic
 */
export async function logoutUser(params: LogoutUserParams) {
    return logoutUserCore({
        ...params,
        performApiLogout,
    });
}
